<script setup>
import { onMounted, ref, onUnmounted } from 'vue';
import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BreezeNavLink from '@/Components/NavLink.vue';
import BreezeResponsiveNavLink from '@/Components/ResponsiveNavLink.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import UnensAlert from "@/Components/UnensAlert.vue";
import helpers from '@/Common/helpers';


import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiBellRingOutline,
    mdiPlus,
    mdiHome,
    mdiBookOpenVariant

} from "@mdi/js";

const props = defineProps({
    categoryChild: Object,
    categoryParent: Object,
    filterCat: {
        type: Number,
        default: 0
    },
    filterLab: {
        type: String,
        default: ''
    },
    qtyCart: {
        type: Number,
        default: 0
    },
    analyticsUrl: String,
    analyticsCode: String
    //connstantes: Array
})

/* document.addEventListener("DOMContentLoaded", () => {
    const navbar = document.getElementById("navbar");
    const sidebar = document.getElementById("sidebar");
    const btnSidebarToggler = document.getElementById("btnSidebarToggler");
    const navClosed = document.getElementById("navClosed");
    const navOpen = document.getElementById("navOpen");

    btnSidebarToggler.addEventListener("click", (e) => {
        e.preventDefault();
        sidebar.classList.toggle("show");
        navClosed.classList.toggle("hidden");
        navOpen.classList.toggle("hidden");

    })

        ;

    // sidebar.style.top = parseInt(navbar.clientHeight) - 1 + "px";
}); */
// Año
const currentYear = ref(new Date().getFullYear());

// Search
const searchCat = ref(props.filterCat)
const searchLab = ref(props.filterLab)

// menu categoria
const sidemenuactive = ref(false)
const sidebaractive = ref(false)
const navClosedActive = ref(false)
const navOpenActive = ref(true)

const sidemenu = () => {
    sidemenuactive.value = !sidemenuactive.value

    if (sidemenuactive.value) {
        sidebaractive.value = true
        navClosedActive.value = true
        navOpenActive.value = false
    } else {
        sidemenuactive.value = false
        sidebaractive.value = false
        navClosedActive.value = false
        navOpenActive.value = true
    }
}

let myRadios = document.getElementsByName('categorymenu');
let setCheck;
let x = 0;
for (x = 0; x < myRadios.length; x++) {
    myRadios[x].onclick = function () {
        if (setCheck != this) {
            setCheck = this;
        } else {
            this.checked = false;
            setCheck = null;
        }
    };
}

const searchEnter = () => {
    let button = document.getElementById('button-search');
    button.click();
}

onMounted(() => {
    getCart()
});

//const car = ref() // <-- Detalle de items
const cantCart = ref(0)
const getCart = () => {
    let cart = []
    //let cartStorage = localStorage.getItem('car')
    let cartStorage = sessionStorage.getItem('cart')
    if (cartStorage && cartStorage.length > 0) {
        cart = JSON.parse(cartStorage)
        cantCart.value = cart.length
    }
    //return car
}



// Cambio de CSS via Scroll
// const scrollPosition = ref(0);
// const handleScroll = () => {
//   scrollPosition.value = window.scrollY;
// };
// const isScrolled = (threshold) => {
//   return scrollPosition.value > threshold;
// };
// onMounted(() => {
//   window.addEventListener('scroll', handleScroll);
// });
// onUnmounted(() => {
//   window.removeEventListener('scroll', handleScroll);
// });


// Reactive state to track the scroll position
const isHeaderComplete = ref(false);
const handleScroll2 = () => {
    isHeaderComplete.value = window.scrollY > 1;
};
onMounted(() => {
    window.addEventListener('scroll', handleScroll2);
});
onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll2);
});

const isHeader = ref(false);
const handleScroll = () => {
    isHeader.value = window.scrollY > 100;
};
onMounted(() => {
    window.addEventListener('scroll', handleScroll);
});
onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});


</script>

<template>
    <div class="group fixed bottom-[50px] right-[15px] flex items-end justify-end z-[1000]">
        <a :href="'https://wa.me/' + helpers.number2WhatsApp(confGlobal.value.COMPANY_PHONE_MOBILE)" class="text-white shadow-lg flex items-center justify-center p-2 rounded-full bg-[#1BD741] absolute " target="_blank">
            <BaseIcon :path="mdiWhatsapp" class="text-white" :size="45" w="w-10" h="h-10" />
        </a>
    </div>
    <!-- Sidebar start-->
    <div class="z-[60]">
        <!-- <div class="fixed z-39 inset-0 bg-gray-500 bg-opacity-75 transition-opacity h-full w-full">
</div> -->
        <div class="navbar-menu relative z-[60]">
            <div :class="(sidebaractive ? 'sidebarshow' : '')" class="fixed left-0 bottom-0 flex w-full -translate-x-full flex-col overflow-y-auto bg-gray-600 bg-opacity-75 h-screen transition-all duration-500 ease-in-out">
                <nav class="fixed sm:max-w-xs w-3/4 lg:w-80 bg-white h-full py-8">
                    <!-- one category / navigation group -->
                    <div class="px-4 pb-6">
                        <div class="flex justify-between items-center mb-4">
                            <h3 class="text-lg font-medium  text-gray-800">
                                Categorias
                            </h3>
                            <button @click="sidemenu()">
                                <BaseIcon :path="mdiCloseThick" :size="30" class="text-gray-800" w="w-10" h="h-10" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                            </button>
                        </div>

                        <div class="relative h-[calc(100vh-120px)] overflow-y-auto">
                            <div class="sidebar-radio" v-if="categoryParent.length">
                                <div class="border-b tab" v-for="(item, key) in categoryParent" :key="key">
                                    <div class="border-l-2 border-transparent relative">
                                        <input class="w-full absolute z-10 cursor-pointer opacity-0 h-7 top-4 bg-red-500" type="radio" :id="'chck' + key" name="categorymenu">
                                        <header class="flex justify-between items-center p-4 cursor-pointer select-none tab-label" :for="'chck' + key">
                                            <span class="text-sm text-gray-800 font-semibold">
                                                <!-- <Link :href="route('eco-product-category', { id: item.id, parent: item.id })" class="a-color"> -->
                                                {{ item.label }}
                                                <!-- </Link> -->
                                            </span>
                                            <div class="rounded-lg w-7 h-7 flex items-center justify-center tab-icon chevron">
                                                <BaseIcon :path="mdiChevronDown" :size="24" w="w-7" h="h-7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                            </div>
                                        </header>
                                        <div class="tab-content">
                                            <div class="pt-0 pb-3 px-4 text-xs  text-gray-600">
                                                <ul class="list-none space-y-2" v-if="categoryChild.length">
                                                    <li>
                                                        <Link :href="route('eco-product-category', { id: item.id, parent: item.id })" class="a-color">
                                                            <span class="text-sm text-gray-800 font-semibold">Ver todo</span>
                                                        </Link>
                                                    </li>
                                                    <template v-for="(subitem, subkey) in categoryChild" :key="subkey">

                                                        <li v-if="subitem.fk_parent == item.id">
                                                            <Link :href="route('eco-product-category', { id: subitem.id })" class="a-color">
                                                                {{ subitem.label }}
                                                            </Link>
                                                        </li>
                                                    </template>
                                                    <!-- <li>
                                                        <Link :href="route('eco-product-category', { id: 2 })" class="a-color">
                                                        Procesadores
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        Memorias Ram
                                                    </li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="confGlobal.value.ECOMMERCE_URL_TICKET_SOPORTE" class="flex p-4 w-full justify-center">
                                <a :href="confGlobal.value.ECOMMERCE_URL_TICKET_SOPORTE" target="_blank">
                                    <button class="btn-color h-[36px] px-5 lg:text-normal">Ticket de Soporte</button>
                                </a>
                            </div>
                        </div>

                    </div>
                    <!-- navigation group end-->
                </nav>
                <div @click="sidemenu()" class="h-full overflow-hidden">
                </div>
            </div>
        </div>
    </div>
    <!-- Sidebar end -->
    <div class="p-0 bg-gray-100">

        <div class="z-50 top-0 w-full bg-white header-complete" :class="{ 'scrolled': isHeaderComplete }">
            <header>
                <div class="header-topbar w-full" :class="(confGlobal.value.HEAD_INFO_OFERTA ? 'border-b lg:border-b border-gray-200' : 'border-b-0 lg:border-b lg:border-gray-200'), { 'scrolled': isHeader }">
                    <div class="mx-auto pl-4 sm:px-6 lg:px-8 flex items-center max-w-full w-full gap-3">

                        <!-- <div v-if="confGlobal.value.HEAD_INFO_OFERTA" class="flex justify-start grow gap-3 py-2">
                                <div v-html="confGlobal.value.HEAD_INFO_OFERTA"></div>
                            </div> -->

                        <!-- <div class="overflow-hidden w-full">
                            <div v-if="confGlobal.value.HEAD_INFO_OFERTA" class="flex items-center justify-center md:justify-start animate-infinite-scroll flex-row gap-8">
                                
                                <div v-html="confGlobal.value.HEAD_INFO_OFERTA" class="text-nowrap" style="text-wrap: nowrap;"></div>
                                <div v-html="confGlobal.value.HEAD_INFO_OFERTA" class="text-nowrap" style="text-wrap: nowrap;"></div>
                                <div v-html="confGlobal.value.HEAD_INFO_OFERTA" class="text-nowrap" style="text-wrap: nowrap;"></div>
                            </div>
                        </div> -->
                        <div class="overflow-hidden w-full">
                            <div v-if="confGlobal.value.HEAD_INFO_OFERTA" class="flex-row gap-12 items-center inline-flex overflow-hidden marquee-content animate-marquee">
                                <div v-html="confGlobal.value.HEAD_INFO_OFERTA" style="text-wrap: nowrap;"></div>
                            </div>
                        </div>
                        <div class="flex flex-row gap-3 h-[32px] lg:h-[36px]">
                            <div class="hidden lg:flex justify-end grow gap-3 py-2">
                                <ul class="hidden flex-row items-center sm:flex ">
                                    <li class="inline after:content-['|'] after:px-3">
                                        <Link :href="route('eco-companyinfo')" class="text-xs text-gray-600 a-color" style="text-wrap: nowrap;">Sobre Nosotros</Link>
                                    </li>
                                    <li class="inline after:content-['|'] after:px-3">
                                        <Link :href="route('eco-termsconditions')" class="text-xs text-gray-600 a-color text-nowrap" style="text-wrap: nowrap;">Términos y condiciones</Link>
                                    </li>
                                    <li class="inline after:content-['|'] after:px-3">
                                        <Link :href="route('eco-warrantypolicies')" class="text-xs text-gray-600 a-color text-nowrap" style="text-wrap: nowrap;">Políticas de Garantía</Link>
                                    </li>
                                </ul>
                            </div>
                            <a v-if="confGlobal.value.ECOMMERCE_URL_TICKET_SOPORTE" :href="confGlobal.value.ECOMMERCE_URL_TICKET_SOPORTE" target="_blank" class="btn-color flex items-center px-4" style="text-wrap: nowrap;">
                                Ticket de Soporte
                            </a>
                        </div>
                    </div>
                </div>
                <div class="bg-white w-full">
                    <div class="mx-auto px-4 sm:px-6 lg:px-8">
                        <!-- <div class="h-16 lg:h-28 flex items-center"> -->
                        <div class="header-main flex items-center justify-between lg:space-x-12" :class="{ 'scrolled': isHeader }">
                            <!-- logo -->
                            <div class="h-8 lg:max-w-auto lg:h-12 flex-shrink-0">
                                <Link href="/">
                                    <img v-if="confGlobal.value.COMPANY_LOGO_PATH" class="h-full" :src="confGlobal.value.COMPANY_LOGO_PATH" alt="">
                                </Link>
                            </div>

                            <!-- search -->
                            <!-- <div class="grow lg:block hidden">
                                    <div class="rounded-md flex items-center select-color-light">
                                        <select name="select" v-model="searchCat" class="rounded-none !rounded-l-lg select-color z-10 w-36 max-w-40 h-[42px] ">
                                            <option value="0" disabled selected hidden>Categorias</option>
                                            <option v-for="(item, key) in categoryChild" :key="key" :value="item.id">{{ item.label }}</option>
                                        </select>


                                        <input class="h-[42px] px-3 border- !rounded-none text-sm pl-4 w-full !border-x-0" type="text" v-model="searchLab" @keyup.enter="searchEnter()" placeholder="Yo estoy buscando...">


                                        <Link :href="route('eco-product-category', { id: searchCat, label: searchLab })">
                                        <button id="button-search" ref="button-search" class="inline-flex h-[42px] px-3 text-white btn-color rounded-r-lg items-center text-sm leading-4 font-medium transition ease-in-out duration-150">

                                            <BaseIcon :path="mdiMagnify" :size="24" class="text-white" />
                                        </button>
                                        </Link>
                                    </div>
                                </div> -->

                            <div class="grow lg:block hidden">
                                <div class="relative w-full">
                                    <select name="select" v-model="searchCat" class="absolute left-1 top-1 flex items-center h-[38px] select-color z-10 w-36 2xl:w-44 max-w-40 2xl:max-w-60 py-0 rounded">
                                        <option value="0" disabled selected hidden>Categorias</option>
                                        <option v-for="(item, key) in categoryChild" :key="key" :value="item.id">{{ item.label }}</option>
                                    </select>

                                    <input id="search_smartphone" class="!h-[46px] pl-40 2xl:pl-48 pr-16 text-sm w-full transition-transform ease-out duration-300" type="text" v-model="searchLab" @keyup.enter="searchEnter()" placeholder="Yo estoy buscando..." />
                                    <Link :href="route('eco-product-category', { id: searchCat, label: searchLab })">
                                        <button id="button-search" ref="button-search" class="absolute h-[38px] right-1 top-1 my-auto p-1 px-3 flex items-center btn-color rounded" type="button">
                                            <BaseIcon :path="mdiMagnify" :size="20" class="text-white" w="w-6" h="h-6"></BaseIcon>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            <!-- phone number -->
                            <div class="flex items-center space-x-4">
                                <div class="hidden sm:flex flex-col place-items-end">
                                    <span class="font-bold text-sm lg:text-md xl:text-xl">{{ helpers.number2Phone(confGlobal.value.COMPANY_PHONE, 'fijo') }}</span>
                                    <span class="font-semibold text-xs xl:text-sm text-gray-400">Ventas 24/7</span>
                                </div>

                                <!-- buttons -->
                                <div class="contents">
                                    <ul class="ml-4  flex items-center justify-end">
                                        <li class="ml-2 lg:ml-4 relative inline-block">
                                            <Link class="" :href="route('login')">
                                                <BaseIcon :path="mdiAccountOutline" :size="30" class="text-gray-600 icon-color-black" w="w-10" h="h-10" />
                                            </Link>
                                        </li>
                                        <!-- <li class="ml-2 lg:ml-4 relative inline-block">
                                            <a class="" href="">
                                                <div class="absolute -top-1 -right-1 z-10 bg-rose-600 text-white text-xs font-bold px-2 py-0.5 rounded-lg">3</div>
                                                <BaseIcon :path="mdiHeartOutline" :size="30" class="text-gray-500" w="w-10" h="h-10" />
                                            </a>
                                        </li> -->
                                        <li class="ml-2 lg:ml-4 relative inline-block">
                                            <Link class="" :href="route('eco-shoppingcart')">
                                                <div v-if="(qtyCart > 0 || cantCart > 0)" class="absolute -top-1 -right-1 z-10 bg-rose-600 text-white text-xs font-bold px-2 py-0.5 rounded-lg">{{ (qtyCart ? qtyCart : cantCart) }}</div>
                                                <BaseIcon :path="mdiCartOutline" :size="30" id="button-carrito" class="text-gray-600 icon-color-black" w="w-10" h="h-10" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <!-- cart count -->
                            <!-- <div class="ml-4 hidden sm:flex flex-col font-bold text-right">
                                    <Link class="" :href="route('eco-shoppingcart')">
                                        <span class="text-xs text-gray-400">Tu carrito</span>
                                        <span>S/ 550.90</span>
                                    </Link>
                                </div> -->
                        </div>
                    </div>
                </div>
                <div class="bg-color">
                    <div class="mx-auto px-4 sm:px-6 lg:px-8">
                        <!-- component -->
                        <!--
                                Change class "fixed" to "sticky" in "navbar" (l. 33) so the navbar doesn't hide any of your page content!
                                -->
                        <!-- menu abrir categorias -->
                        <nav id="navbar" class="z-20 flex flex-row bg-color justify-between py-0 lg:py-2 space-x-4">
                            <button id="btnSidebarToggler" @click="sidemenu()" type="button" class="inline-flex items-center text-white">
                                <BaseIcon v-show="navOpenActive" :path="mdiMenu" :size="28" class="text-white" w="w-8" h="h-8"></BaseIcon>
                                <BaseIcon v-show="navClosedActive" :path="mdiCloseThick" :size="28" class=" text-white" w="w-8" h="h-8"></BaseIcon>
                                <p class="hidden lg:inline-block text-xs lg:text-sm pl-5">Todas las categorias</p>
                            </button>
                            <div class="grow flex lg:hidden items-center select-color-light my-2">
                                <div class="relative w-full">
                                    <input id="search_pc" type="text" class="pr-10 h-10 p-2 text-sm w-full !border-none !ring-0 transition-transform ease-out duration-300" v-model="searchLab" @keyup.enter="searchEnter()" placeholder="Yo estoy buscando..." />
                                    <Link :href="route('eco-product-category', { id: searchCat, label: searchLab })">
                                        <button class="absolute h-8 w-8 right-1 top-1 my-auto p-1 flex items-center btn-color rounded hover:bg-blue-800" type="button">
                                            <BaseIcon :path="mdiMagnify" :size="20" class="text-white" w="w-6" h="h-6"></BaseIcon>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            <div class="flex items-center lg:hidden">
                                <Link href="/">
                                    <BaseIcon :path="mdiHome" :size="28" w="w-8" h="h-8" class="text-white"></BaseIcon>
                                </Link>
                            </div>
                            <ul class="flex-row items-center text-xs lg:text-sm text-white m-0 lg:flex hidden">
                                <li class="inline after:pr-4">
                                    <Link href="/">Inicio</Link>
                                </li>
                                <li class="inline after:pr-4 ">
                                    <Link :href="route('eco-services')">Servicios</Link>
                                </li>
                                <li class="inline after:pr-4 ">
                                    <Link :href="route('eco-paymentmethods')">Métodos de Pago</Link>
                                </li>
                                <!-- <li class="inline after:pr-4">
                                        <a href="#">Marcas</a>
                                    </li> -->
                                <!-- <li class="inline after:pr-4">
                                        <a href="#">Courier - Envio</a>
                                    </li> -->
                            </ul>
                        </nav>
                        <!-- Navbar end -->



                    </div>
                </div>
            </header>
        </div>

        <div class="w-full bg-white overflow-hidden">
            <UnensAlert />
            <slot />
        </div>

        <footer>
            <div class="w-full">
                <!-- Sucribete -->
                <!-- <div class="bg-color">
                    <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
                        <div class="flex flex-col lg:flex-row items-center w-full mx-auto text-left rounded  dark:border-gray-700 gap-4">
                            <div class="flex flex-row items-center w-full mb-5 md:mb-0 md:pr-5 lg:pr-10 lg:w-3/5">
                                <div class="pr-6">
                                    <svg viewBox="0 0 100 100" height="75" xmlns="http://www.w3.org/2000/svg">
                                        <g style="fill:none;fill-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke:#ffffff;stroke-width:4">
                                            <path d="m44.3222087 70.4438714 52.3985134-63.9434163-13.8918386 77.4534284z" />
                                            <path d="m30.345267 66.1268204 9.7190534 28.4745146 4.8722694-24.8237258 52.1850728-64.16049755z" />
                                            <path d="m2.00182039 55.1708131 94.47451461-49.22330096-65.8434467 60.03094656z" />
                                            <path d="m40.6550364 93.530264 19.0212379-17.7114685-14.920358-5.167855z" />
                                        </g>
                                    </svg>
                                </div>
                                <div>
                                    <h3 class="mb-2 text-base lg:text-2xl font-bold text-white">
                                        Suscríbete al boletín informativo</h3>
                                    <p class="text-white text-xs lg:text-sm">Ingresa tu correo para recibir notificaciones cuando lancemos
                                        nuevos productos o promociones.
                                    </p>
                                </div>
                            </div>
                            <div class="w-full px-1 flex-0 lg:w-2/5">
                                <form novalidate="">
                                    <input type="hidden" name="tags" value="earlyaccess">
                                    <div class="flex flex-col sm:flex-row gap-2">
                                        <input type="email" id="email" name="email" placeholder="Ingresa tu correo" class="w-full h-[42px] border-none">
                                        <button type="submit" class="btn btn-slate h-[42px]"> Suscribete </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div> -->
                <div class="bg-white">
                    <div class="bg-zinc-100 mx-auto px-4 sm:px-6 lg:px-8 py-16">
                        <div class="grid grid-cols-1 gap-8 lg:grid-cols-5">
                            <div class="lg:col-span-2">
                                <img v-if="confGlobal.value.COMPANY_LOGO_PATH" class="h-12 md:h-16 mb-4" :src="confGlobal.value.COMPANY_LOGO_PATH" alt="">
                                <div class="flex space-x-3 items-center mb-4">
                                    <div>
                                        <BaseIcon :path="mdiHeadset" :size="45" class="icon-color" w="w-14" h="h-14"></BaseIcon>
                                    </div>
                                    <div>
                                        <p class="text-gray-900 text-xs tracking-wide mb-1">¿Tienes consultas? Llamanos ahora...</p>
                                        <p class="text-base lg:text-xl"><a :href="'tel:' + confGlobal.value.COMPANY_PHONE" class="a-color">{{ helpers.number2Phone(confGlobal.value.COMPANY_PHONE, 'fijo') }}</a>, <a :href="'tel:' + confGlobal.value.COMPANY_PHONE_MOBILE" class="a-color">{{ helpers.number2Phone(confGlobal.value.COMPANY_PHONE_MOBILE, 'celular') }}</a></p>
                                    </div>
                                </div>
                                <div>
                                    <h4 class="mb-2">Oficina Principal</h4>
                                    <p class="text-xs text-gray-600">
                                        {{ [confGlobal.value.COMPANY_CONTACT_ADDRESS, confGlobal.value.COMPANY_CONTACT_CITY, confGlobal.value.COMPANY_CONTACT_STATE].filter(Boolean).join(', ') }}
                                    </p>
                                </div>

                                <div class="flex mt-8 space-x-6 text-gray-600">
                                    <a v-if="confGlobal.value.SOCIAL_URL_FACEBOOK" class="hover:text-[#0866FF] transition ease-in-out duration-150" :href="confGlobal.value.SOCIAL_URL_FACEBOOK" target="_blank" rel="noreferrer">
                                        <BaseIcon :path="mdiFacebook" :size="24" w="w-6" h="h-6"></BaseIcon>
                                    </a>
                                    <a v-if="confGlobal.value.SOCIAL_URL_INSTAGRAM" class="hover:text-[#FF0069] transition ease-in-out duration-150" :href="confGlobal.value.SOCIAL_URL_INSTAGRAM" target="_blank" rel="noreferrer">
                                        <BaseIcon :path="mdiInstagram" :size="24" w="w-6" h="h-6"></BaseIcon>
                                    </a>
                                    <a v-if="confGlobal.value.SOCIAL_URL_TWITTER" class="hover:text-[#009DEC] transition ease-in-out duration-150" :href="confGlobal.value.SOCIAL_URL_TWITTER" target="_blank" rel="noreferrer">
                                        <BaseIcon :path="mdiTwitter" :size="24" w="w-6" h="h-6"></BaseIcon>
                                    </a>
                                    <a v-if="confGlobal.value.SOCIAL_URL_YOUTUBE" class="hover:text-[#FF0000] transition ease-in-out duration-150" :href="confGlobal.value.SOCIAL_URL_YOUTUBE" target="_blank" rel="noreferrer">
                                        <BaseIcon :path="mdiYoutube" :size="24" w="w-6" h="h-6"></BaseIcon>
                                    </a>
                                    <a v-if="confGlobal.value.SOCIAL_URL_WHATSAPP" class="hover:text-[#25D366] transition ease-in-out duration-150" :href="confGlobal.value.SOCIAL_URL_WHATSAPP" target="_blank" rel="noreferrer">
                                        <BaseIcon :path="mdiWhatsapp" :size="24" w="w-6" h="h-6"></BaseIcon>
                                    </a>
                                </div>
                            </div>
                            <div class="lg:col-span-3">
                                <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
                                    <div>
                                        <p class="font-medium">
                                            Link Populares
                                        </p>
                                        <nav class="flex flex-col mt-4 space-y-2 text-sm text-gray-500">
                                            <a v-if="confGlobal.value.LINK_FOOTER_URL_1" class="text-gray-700 a-color" :href="confGlobal.value.LINK_FOOTER_URL_1" target="_blank"> {{ confGlobal.value.LINK_FOOTER_LABEL_1 }} </a>
                                            <a v-if="confGlobal.value.LINK_FOOTER_URL_2" class="text-gray-700 a-color" :href="confGlobal.value.LINK_FOOTER_URL_2" target="_blank"> {{ confGlobal.value.LINK_FOOTER_LABEL_2 }} </a>
                                            <a v-if="confGlobal.value.LINK_FOOTER_URL_3" class="text-gray-700 a-color" :href="confGlobal.value.LINK_FOOTER_URL_3" target="_blank"> {{ confGlobal.value.LINK_FOOTER_LABEL_3 }} </a>
                                            <a v-if="confGlobal.value.LINK_FOOTER_URL_4" class="text-gray-700 a-color" :href="confGlobal.value.LINK_FOOTER_URL_4" target="_blank"> {{ confGlobal.value.LINK_FOOTER_LABEL_4 }} </a>

                                            <a v-if="confGlobal.value.ECOMMERCE_URL_TICKET_SOPORTE" class="text-gray-700 a-color" :href="confGlobal.value.ECOMMERCE_URL_TICKET_SOPORTE" target="_blank"> Ticket de Soporte </a>
                                        </nav>
                                    </div>
                                    <div>
                                        <p class="font-medium">
                                            Conócenos
                                        </p>
                                        <nav class="flex flex-col mt-4 space-y-2 text-sm text-gray-500">
                                            <Link class="text-gray-700 a-color" :href="route('eco-companyinfo')"> Sobre Nosotros </Link>
                                            <Link class="text-gray-700 a-color" :href="route('eco-contactinfo')"> Contáctanos </Link>
                                            <Link class="text-gray-700 a-color" :href="route('eco-services')"> Nuestros Servicios </Link>
                                            <Link class="text-gray-700 a-color" :href="route('eco-brands')"> Marcas que ofrecemos </Link>
                                        </nav>
                                    </div>
                                    <div>
                                        <p class="font-medium">
                                            Legal
                                        </p>
                                        <nav class="flex flex-col mt-4 space-y-2 text-sm text-gray-500">
                                            <Link class="text-gray-700 a-color" :href="route('eco-termsconditions')"> Términos y Condiciones </Link>
                                            <Link class="text-gray-700 a-color" :href="route('eco-warrantypolicies')"> Política de Garantía </Link>
                                            <Link class="text-gray-700 a-color" :href="route('eco-deliverytypes')"> Tipos de Entrega </Link>
                                            <Link class="text-gray-700 a-color" :href="route('eco-legalbases')"> Bases Legales</Link>

                                        </nav>
                                    </div>
                                </div>
                                <div v-if="confGlobal.value.ECOMMERCE_ENABLE_LIBRO_RECLAMACIONES" class="grid grid-cols-1 gap-6 xl:grid-cols-3 mt-8">
                                    <div class="col-span-1 xl:col-start-3">
                                        <div class="flex items-center gap-4">
                                            <Link class="text-gray-800 text-base a-color" :href="route('eco-complaintsbook')"><img class="h-full max-w-[200px] xl:max-w-[250px]" src="/img/reclamaciones.png" alt=""></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-zinc-200">
                    <div class="mx-auto px-4 sm:px-6 lg:px-8 border-t border-gray-200">
                        <div class="grid grid-cols-1 gap-4 lg:flex justify-between items-center py-4 lg:py-3">
                            <div class="col-span-1 order-2 lg:order-1 w-full lg:w-auto">
                                <p class="text-xs text-gray-800 hidden lg:block">
                                    © Unens Ecommerce Rev. {{ confGlobal.value.UNENS_VERSION }} - <a href="https://unens.com" target="_blank">Unens.com</a> | All Rights Reserved {{ currentYear }}
                                </p>
                                <p class="text-xs text-gray-800 block lg:hidden text-center">
                                    © Unens Ecommerce Rev. {{ confGlobal.value.UNENS_VERSION }} - <a href="https://unens.com" target="_blank">Unens.com</a> <br> All Rights Reserved {{ currentYear }}
                                </p>
                            </div>

                            <div class="col-span-1 order-1 lg:order-2 w-full lg:w-auto">
                                <ul class="flex items-center justify-center">
                                    <li class="inline mx-3"><a href="#" class="transition ease-in-out duration-150 hover:grayscale"><img class="h-6 w-auto" src="/img/marcas/yape.svg" alt=""></a></li>
                                    <li class="inline mx-3"><a href="#" class="transition ease-in-out duration-150 hover:grayscale"><img class="h-6 w-auto" src="/img/marcas/mastercard.svg" alt=""></a></li>
                                    <li class="inline mx-3"><a href="#" class="transition ease-in-out duration-150 hover:grayscale"><img class="h-6 w-auto" src="/img/marcas/visa.svg" alt=""></a></li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </footer>
    </div>
</template>

<style>
/* END - Menu con input */
</style>